var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 234,
    viewBox: "0 0 311 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.582 7.17096C288.493 -3.14067 297.967 14.9256 287.307 15.7572C276.647 16.5888 229.969 -1.38389 222 13.6472C214.031 28.6783 262.301 55.6681 262.822 70.1724C263.342 84.6767 199.616 105.68 199.616 114.683C199.616 123.685 249.589 125.182 250.11 139.186C250.63 153.19 206.904 157.691 199.616 156.191C192.329 154.69 179.835 161.693 173.068 159.692C166.301 157.691 166.822 144.688 152.767 143.187C138.712 141.687 124.657 152.69 116.849 163.693C109.041 174.696 105.917 186.2 90.8213 196.203C75.7254 206.206 59.0678 189.701 47.6157 191.201C36.1636 192.702 42.4102 208.206 37.2047 218.709C31.9992 229.212 25.7526 229.918 21.0677 228.712C16.3827 227.506 8.05393 218.709 5.45118 208.206C2.84843 197.703 3.36981 188.2 10.1357 194.202",
    stroke: "#FF0400",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageline);
export default __webpack_public_path__ + "static/media/imageline.228b8bd0e830b2c52158359ad6d39e1a.svg";
export { ForwardRef as ReactComponent };